<!-- @migration task: review uses of `navigating` -->
<script lang="ts">
  import { navigating, page } from '$app/state'
  import LiveChat from '$lib/components/LiveChat.svelte'
  import Seo from '$lib/components/Seo.svelte'
  import PreloadingIndicator from '$lib/components/ui/PreloadingIndicator.svelte'
  import '$lib/styles/app.css'
  import '@fontsource-variable/dm-sans/opsz.css'
  import '@fontsource/roboto-mono/400.css'
  interface Props {
    children?: import('svelte').Snippet
  }

  let { children }: Props = $props()
</script>

<svelte:head>
  <link rel="canonical" href="https://www.pausly.app{page.url.pathname}" />
</svelte:head>

<Seo />

<LiveChat />

{#if navigating.to}
  <PreloadingIndicator />
{/if}

{@render children?.()}
